export default "/_next/static/chunks/fonts/Readex Pro Bold-fe35669fb47f7e54d49d2e5d20753ba1.ttf";